"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.graphqlMutation = void 0;
var react_components_1 = require("@apollo/react-components");
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var React = __importStar(require("react"));
var App_1 = require("../../App");
// tslint:disable-next-line:max-line-length
var RestMutations_1 = require("../../Common/RestMutations");
exports.graphqlMutation = graphql_tag_1["default"](templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation cardReentryBFF($paymentCardId: ID!, $stripeToken: String!) {\n    cardReentry(paymentCardId: $paymentCardId, stripeToken: $stripeToken)\n  }\n"], ["\n  mutation cardReentryBFF($paymentCardId: ID!, $stripeToken: String!) {\n    cardReentry(paymentCardId: $paymentCardId, stripeToken: $stripeToken)\n  }\n"])));
var CardReentryMutation = function (_a) {
    var children = _a.children;
    var client = React.useContext(App_1.RiskContext).client;
    return (React.createElement(react_components_1.Mutation, { mutation: client ? exports.graphqlMutation : RestMutations_1.verifyPaymentCardRest }, function (mutate, res) {
        var cardReentry = function (paymentCardId, stripeToken) {
            return mutate({ variables: { paymentCardId: paymentCardId, stripeToken: stripeToken } });
        };
        return children(cardReentry, res);
    }));
};
exports["default"] = CardReentryMutation;
var templateObject_1;
